import { getAllEvents } from '../supabase/events'; 

// Admin user IDs - define once and freeze
export const ADMIN_USER_IDS = Object.freeze([
  '44d78f29-b610-434f-9fdb-3d256bac8fd0', //dev
  '58181546-d835-46b2-8e88-8de0241077f2' //prod
]);

// Check if user is admin
export const isAdmin = (userId) => {
  if (!userId) return false;
  return ADMIN_USER_IDS.includes(userId);
};

// Check if user has reached daily event creation limit
export const checkDailyEventLimit = async (userId) => {
  if (!userId) {
    return { allowed: false, count: 0, limit: 3, error: 'No user ID' };
  }
  
  // Admins have no limit
  if (isAdmin(userId)) {
    return { allowed: true, count: 0, limit: 'unlimited', isAdmin: true };
  }
  
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  
  // Get all events from Supabase
  const { success, events } = await getAllEvents();
  
  if (!success) {
    return { allowed: false, count: 0, limit: 3, error: 'Failed to check event limit' };
  }
  
  const userEventsToday = events.filter(e => {
    const createdAt = new Date(e.createdAt);
    return e.creatorId === userId && 
           createdAt >= todayStart && 
           createdAt <= todayEnd;
  });
  
  const DAILY_LIMIT = 3;
  const count = userEventsToday.length;

  return {
    allowed: count < DAILY_LIMIT,
    count,
    limit: DAILY_LIMIT,
    remaining: DAILY_LIMIT - count,
    isAdmin: false
  };
};